"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WebSocketState;
(function (WebSocketState) {
    WebSocketState[WebSocketState["CONNECTING"] = 0] = "CONNECTING";
    WebSocketState[WebSocketState["OPEN"] = 1] = "OPEN";
    WebSocketState[WebSocketState["CLOSING"] = 2] = "CLOSING";
    WebSocketState[WebSocketState["CLOSED"] = 3] = "CLOSED";
})(WebSocketState = exports.WebSocketState || (exports.WebSocketState = {}));
var RealTimeMessageTypes;
(function (RealTimeMessageTypes) {
    RealTimeMessageTypes["Command"] = "command";
    RealTimeMessageTypes["CommandResponse"] = "command response";
    RealTimeMessageTypes["EventMessage"] = "event";
    RealTimeMessageTypes["Notification"] = "notification";
})(RealTimeMessageTypes = exports.RealTimeMessageTypes || (exports.RealTimeMessageTypes = {}));
var RealTimeCommandTypes;
(function (RealTimeCommandTypes) {
    RealTimeCommandTypes["Subscribe"] = "subscribe";
    RealTimeCommandTypes["UnSubscribe"] = "unsubscribe";
    RealTimeCommandTypes["JwtRefresh"] = "jwt replace";
    RealTimeCommandTypes["Publish"] = "publish";
})(RealTimeCommandTypes = exports.RealTimeCommandTypes || (exports.RealTimeCommandTypes = {}));
var NotificationCodes;
(function (NotificationCodes) {
    NotificationCodes["TokenAboutToExpire"] = "1";
})(NotificationCodes = exports.NotificationCodes || (exports.NotificationCodes = {}));
var CommandErrorCodes;
(function (CommandErrorCodes) {
    CommandErrorCodes["InternalError"] = "1";
    CommandErrorCodes["Unauthorized"] = "2";
    CommandErrorCodes["InvalidToken"] = "3";
    CommandErrorCodes["BadFormatting"] = "4";
    CommandErrorCodes["UnknownType"] = "5";
    CommandErrorCodes["UnknownCommand"] = "6";
    CommandErrorCodes["UnknownResourceType"] = "1000";
    CommandErrorCodes["UnknownResourceName"] = "1001";
    CommandErrorCodes["UnknownAction"] = "1002";
})(CommandErrorCodes = exports.CommandErrorCodes || (exports.CommandErrorCodes = {}));
